import * as types from '../../action-types';
import { getHansaAccount as initialState } from "../../initialState";

const getHansaAccount = (state=initialState, action) => {  

  console.log('MRA getHansaAccount Reducer'); 

  switch (action.type) {    
    case types.GET_HANSA_ACCOUNT_FAIL:
      return {
        ...state,
        isLoading: false,
        data: '',
        error: action.payload,
        isSuccessful:false
      }; 
    case types.GET_HANSA_ACCOUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: '',
        isSuccessful:true
      }; 
    default:
      return state;
  }
}

export default getHansaAccount;
